@if (lesson) {
	<div>
		@if (lesson.active_text?.image_uri) {
			<img class="image" [src]="lesson.active_text?.image_uri" />
		}
		@if (!lesson.active_text?.image_uri) {
			<div class="image"></div>
		}
		<div class="text-container">
			<div class="title">
				{{ lesson.active_text?.name }}
			</div>
			<div class="description-short">
				{{ lesson.active_text?.description_short }}
			</div>
		</div>
	</div>
}
